import type { LifeFeatureConfig } from '../../../types/insurances/LifeFeatureConfig';

export const life: LifeFeatureConfig = {
    overview: {
        useCountrySpecificApi: false,
        useBeneficiaryApi: true,
        highlight: {
            showNextPaymentDate: true,
        },
        details: {
            showContractedInsurances: true,
            showVariant: false,
            showPackage: true,
            showContractNumber: true,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
        showCoveredRisks: false,
        showUncoveredRisks: false,
        showInsuredPersons: false,
        showBeneficiaries: false,
    },
    history: {
        visible: false,
    },
    risks: {
        visible: true,
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
